import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimularAutosComponent } from '../../components/simular-autos/simular-autos.component';

@Component({
	standalone: true,
	imports: [CommonModule, SimularAutosComponent],
	templateUrl: './simular-autos.view.html',
	styleUrls: ['./simular-autos.view.scss'],
  	host: {
		'data-view-id': 'simular-autos-view'
	}
})
export class SimularAutosView {}
